<template>
    <CardFront :title="title">
        <p class="tw:mb-0 tw:text-sm tw:font-medium tw:text-slate-400">{{ itemCountLabel }}</p>

        <div
            v-if="!items.length"
            class="tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-2 tw:rounded-lg tw:border tw:border-dashed tw:border-slate-200 tw:bg-slate-50 tw:px-4 tw:py-8 tw:text-center"
        >
            <i class="material-icons tw:text-3xl tw:text-slate-300">checkroom</i>
            <p class="tw:m-0 tw:text-sm tw:text-slate-400">{{ emptyLabel }}</p>
        </div>

        <div v-else class="tw:flex tw:flex-col tw:overflow-hidden tw:rounded-lg tw:border tw:border-slate-200 tw:divide-y tw:divide-slate-100">
            <div
                v-for="item in items"
                :key="item.id"
                class="tw:flex tw:flex-col tw:gap-3 tw:bg-white tw:px-4 tw:py-4 tw:sm:flex-row tw:sm:items-center tw:sm:justify-between"
            >
                <div class="tw:flex tw:min-w-0 tw:items-center tw:gap-3">
                    <div
                        v-if="item.imagen"
                        class="tw:flex tw:h-12 tw:w-12 tw:flex-shrink-0 tw:items-center tw:justify-center tw:overflow-hidden tw:rounded-lg tw:border tw:border-slate-200 tw:bg-slate-50"
                    >
                        <img
                            :src="item.imagen"
                            :alt="`${imageLabel} ${item.nombre}`"
                            class="tw:h-full tw:w-full tw:object-cover"
                        />
                    </div>

                    <div class="tw:min-w-0">
                        <p class="tw:m-0 tw:text-sm tw:font-bold tw:text-slate-900">{{ item.nombre }}</p>
                        <p v-if="item.meta" class="tw:mt-1 tw:mb-0 tw:text-sm tw:text-slate-400">{{ item.meta }}</p>
                    </div>
                </div>

                <div v-if="item.badges.length" class="tw:flex tw:flex-wrap tw:gap-2 tw:sm:justify-end">
                    <BadgeFront
                        v-for="badge in item.badges"
                        :key="badge.key"
                        :variant="badge.variant"
                        :label="badge.label"
                        :icon="badge.icon"
                        :dot="false"
                    />
                </div>
            </div>
        </div>
    </CardFront>
</template>

<script setup>
    import { computed } from 'vue';
    import { t } from '@/utils/i18n-helper';
    import BadgeFront from '@/modules/front/ui/BadgeFront.vue';
    import CardFront from '@/modules/front/ui/CardFront.vue';

    const props = defineProps({
        items: {
            type: Array,
            default: () => [],
        },
    });

    const title = computed(() => t('perfil.cantera_indumentaria', {}, 'Indumentaria'));
    const emptyLabel = computed(() => t('perfil.cantera_sin_indumentaria', {}, 'Sin indumentaria registrada'));
    const itemCountLabel = computed(() => {
        const count = props.items.length;
        const labelKey = count === 1
            ? 'perfil.cantera_prenda_registrada'
            : 'perfil.cantera_prendas_registradas';
        const label = t(labelKey, {}, count === 1 ? 'prenda registrada' : 'prendas registradas');
        return `${count} ${label}`;
    });
    const imageLabel = computed(() => t('bases.imagen_indumentaria', {}, 'Imagen'));
</script>
